import { createPostEndpoint } from '@sonar-software/sonar-http';

export type PostDataDictionaryShareViewRequest = {
	viewId: number;
};

export type PostDataDictionaryShareViewResponse = {
	sharedViewKey: string;
};

export const postDataDictionaryShareView = createPostEndpoint<
	PostDataDictionaryShareViewRequest,
	PostDataDictionaryShareViewResponse
>(({ viewId }) => `/api/v3/data-dictionary/views/${viewId}/shared-key`);
